// ©2024 Austin App House. All rights reserved.
import React from 'react';
import ContractorCertificatesChecks from '../ContractorCertificatesChecks';
import ContractorRating from '../ContractorRating';
import ContractorPreferedGroupsChecks from '../PreferedGroupsCheck';

const NearByCard = ({
  user,
  handler,
  profileInfo,
  blocked,
  invitedContractors,
  selectedContractors,
  handlerCheckbox,
  viewOnly,
}) => {
  const isBlocked = Object.values(user.block).some(el => el);
  const isInvited = invitedContractors.includes(user.userId);

  return (
    <div className="card_item">
      <div className="card_body">
        <div className="img_card">
          <img
            src={user.image || 'https://www.w3schools.com/css/img_avatar.png'}
            alt="Avatar"
            width="78"
            height="78"
          />
          {user.groups?.length ? (
            <div className="small_img">
              <ContractorPreferedGroupsChecks />
              {/* <span>Preferred groups</span> */}
            </div>
          ) : null}
          {(!viewOnly && !isBlocked && !isInvited) ? (
            <div className="field_block checkbox_group">
              <label htmlFor={user.userId} className="wo-check-btn check_btn dashboard-filter-check">
                <input
                  id={user.userId}
                  name={user.userId}
                  type="checkbox"
                  className="float-right"
                  checked={selectedContractors.has(user.userId)}
                  onChange={(event) => handlerCheckbox(event, user.userId)}
                />
              </label>
            </div>
          ) : null}
        </div>

        <div className="card_main">
          <div
            className="card_title"
            style={{ cursor: 'pointer' }}
            onClick={() => profileInfo(user)}
          >
            {user.name}
          </div>
          <div className="card_title">{user.unique_id}</div>
          <div className="card_address">{user.address}</div>
          <div className="card_address">
            {(user.city && user.city.label) ? ` ${user.city.label},` : ''}
            {(user.state && user.state.label) ? ` ${user.state.label},` : ''}
            <span>{` ${user.zipcode}`}</span>
          </div>
          <div className="card_contacts">
              <div><a href={`tel:${user.phone}`}>{user.phone}</a></div>
              <div><a href={`mailto:${user.email}`}>{user.email}</a></div>
            {(user.distance || user.distance === 0) ? (
              <span>{`Distance - ${user.distance.toFixed(2)} Miles`}</span>
            ) : null}
          </div>
        </div>

        <div className="check_info">
          <ContractorCertificatesChecks certificates={user.certificates} />
        </div>

        <div className="card_statuses">
          <ContractorRating contractor={user} />
        </div>

        <div className="card_actions">
          {viewOnly ? null : isBlocked ? (
            <button
              type="button"
              className="standard_btn danger_btn"
              onClick={() => blocked(user)}
            >
              Blocked
            </button>
          ) : (
            isInvited ? (
              <button
                type="button"
                className="standard_btn light_btn"
                disabled
              >
                Invited
              </button>
            ) : (
              <button
                type="button"
                className="standard_btn dark_btn"
                onClick={() => handler(user)}
              >
                Invite
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default NearByCard;
